<template>

  <div class="ws-fin-forecast">

    <div class="ws-fin-forecast__panel ws-fin-forecast__panel--main">

      <header class="ws-fin-forecast__header">

        <span class="ws-fin-forecast__header-icon" aria-hidden="true">

          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">

            <path stroke-linecap="round" stroke-linejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>

          </svg>

        </span>

        <div>

          <h3 class="ws-fin-forecast__title">{{ t('workspaceFinanceiroServicos.forecast.mesAtual') }}</h3>

          <p class="ws-fin-forecast__header-sub">{{ t('workspaceFinanceiroServicos.forecast.mesAtualSub') }}</p>

        </div>

      </header>



      <div class="ws-fin-forecast__grid">

        <div class="ws-fin-forecast__item ws-fin-forecast__item--danger">

          <span class="ws-fin-forecast__item-icon ws-fin-forecast__item-icon--danger" aria-hidden="true">

            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/></svg>

          </span>

          <span class="ws-fin-forecast__label">{{ t('workspaceFinanceiroServicos.forecast.atrasados') }}</span>

          <MoneyAmount class="ws-fin-forecast__amount" :value="forecast.mesAtual.atrasados.valor" size="md" />

          <span class="ws-fin-forecast__meta">{{ forecast.mesAtual.atrasados.qtd }} {{ t('workspaceFinanceiroServicos.kpi.items') }}</span>

        </div>



        <div class="ws-fin-forecast__item ws-fin-forecast__item--success">

          <span class="ws-fin-forecast__item-icon ws-fin-forecast__item-icon--success" aria-hidden="true">

            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>

          </span>

          <span class="ws-fin-forecast__label">{{ t('workspaceFinanceiroServicos.forecast.recebidos') }}</span>

          <MoneyAmount class="ws-fin-forecast__amount" :value="forecast.mesAtual.recebidos.valor" size="md" />

          <span class="ws-fin-forecast__meta">{{ forecast.mesAtual.recebidos.qtd }} {{ t('workspaceFinanceiroServicos.kpi.items') }}</span>

        </div>



        <div class="ws-fin-forecast__item ws-fin-forecast__item--pending">

          <span class="ws-fin-forecast__item-icon ws-fin-forecast__item-icon--pending" aria-hidden="true">

            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>

          </span>

          <span class="ws-fin-forecast__label">{{ t('workspaceFinanceiroServicos.forecast.previsaoEntrada') }}</span>

          <MoneyAmount class="ws-fin-forecast__amount" :value="forecast.mesAtual.previsaoEntrada.valor" size="md" />

          <span class="ws-fin-forecast__meta">{{ forecast.mesAtual.previsaoEntrada.qtd }} {{ t('workspaceFinanceiroServicos.kpi.items') }}</span>

        </div>



        <div class="ws-fin-forecast__item ws-fin-forecast__item--saldo">

          <span class="ws-fin-forecast__item-icon ws-fin-forecast__item-icon--saldo" aria-hidden="true">

            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/></svg>

          </span>

          <span class="ws-fin-forecast__label">{{ t('workspaceFinanceiroServicos.forecast.saldoLiquido') }}</span>

          <MoneyAmount class="ws-fin-forecast__amount ws-fin-forecast__amount--hero" :value="forecast.mesAtual.saldoLiquido.valor" size="lg" />

          <span v-if="forecast.mesAtual.contasPendentesMes?.qtd" class="ws-fin-forecast__meta ws-fin-forecast__meta--hint">
            {{ t('workspaceFinanceiroServicos.contasPagar.aberto') }}:
            <MoneyAmount :value="forecast.mesAtual.contasPendentesMes.valor" size="sm" />
            ({{ forecast.mesAtual.contasPendentesMes.qtd }})
          </span>

        </div>

      </div>

    </div>



    <div class="ws-fin-forecast__panel ws-fin-forecast__panel--next">

      <header class="ws-fin-forecast__header ws-fin-forecast__header--compact">

        <span class="ws-fin-forecast__header-icon ws-fin-forecast__header-icon--next" aria-hidden="true">

          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>

        </span>

        <div>

          <h3 class="ws-fin-forecast__title">{{ t('workspaceFinanceiroServicos.forecast.proximoMes') }}</h3>

          <p class="ws-fin-forecast__header-sub">{{ t('workspaceFinanceiroServicos.forecast.proximoMesSub') }}</p>

        </div>

      </header>

      <div class="ws-fin-forecast__next-value">

        <MoneyAmount class="ws-fin-forecast__amount ws-fin-forecast__amount--next" :value="forecast.proximoMes.previsaoRecebiveis.valor" size="lg" />

        <span class="ws-fin-forecast__meta ws-fin-forecast__meta--next">

          <strong>{{ forecast.proximoMes.previsaoRecebiveis.qtd }}</strong>

          {{ t('workspaceFinanceiroServicos.forecast.recebiveisPrevistos') }}

        </span>

      </div>

    </div>

  </div>

</template>



<script setup>

import { useI18n } from 'vue-i18n'

import MoneyAmount from '@/components/MoneyAmount.vue'



defineProps({

  forecast: { type: Object, required: true }

})



const { t } = useI18n()

</script>


